const CopyHelper = {
  copyToClipboard: (content) => {
    const tempInput = document.createElement("textarea");
    tempInput.value = content;
    document.body.appendChild(tempInput);
    tempInput.setAttribute("id", "temp_id");
    tempInput.select();
    tempInput.setSelectionRange(0, 99999);
    document.execCommand("copy");
    tempInput.remove();
  },
};

export { CopyHelper };
